var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kv-select-filter',{attrs:{"name":_vm.name,"label":_vm.label,"current-value":_vm.currentValue,"removable":_vm.removable,"searchable":true,"options":_vm.selectOptions},on:{"changed":function($event){return _vm.$emit('changed', $event)},"remove":function($event){return _vm.$emit('remove')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }